import { render, staticRenderFns } from "./RegTable.vue?vue&type=template&id=d47631da"
import script from "./RegTable.vue?vue&type=script&lang=js"
export * from "./RegTable.vue?vue&type=script&lang=js"
import style0 from "./RegTable.vue?vue&type=style&index=0&id=d47631da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports